import React from 'react';

import { InformationTable } from './informationTable';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Information = () => (<InformationTable />);
